import React from "react";
import { Table } from "phosphor-react";

// Components
import MatchHeaders from "./MatchHeaders";
import Modal from "../Modal/Modal";

// Utils
import colors from "../../utils/constants/COLORS";

export default function MatchHeadersModal({ scope }) {
  return (
    <Modal
      size={{ width: "95%", height: "auto" }}
      title={"Please match the uploaded column names to the system column names"}
      icon={
        <Table size={20} weight="fill" color={colors.informational.color} />
      }
    >
      <MatchHeaders scope={scope} />
    </Modal>
  );
}
